import { render, staticRenderFns } from "./SubProductTab.vue?vue&type=template&id=da828dcc&"
import script from "./SubProductTab.vue?vue&type=script&lang=js&"
export * from "./SubProductTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports